<style lang="postcss">
	.label {
		color: rgb(38, 46, 58);
	}
</style>

<script lang="ts">
	import Instructions from "design/Components/Basic/Instructions.svelte";
	export let instructions: string = "";
	const sizes = ["sm", "md", "lg"];
	const classes = $$props.class?.split(" ") || [];
	const labelSize = sizes.filter((a) => classes.includes(a)).length
		? sizes.filter((a) => classes.includes(a))[0]
		: "md";
	export let type: 1 | 2 = 1;
</script>

{#if type === 1}
	<div
		style="font-weight: 440"
		class="label flex flex-row items-center justify-start {labelSize} mb-[.25rem] opacity-100 gap-1 {$$props.class ??
			''}">
		<slot />
		{#if instructions}
			<Instructions instructions="{instructions}" />
		{/if}
	</div>
{:else if type === 2}
	<div
		class="flex flex-row items-center justify-start {labelSize} mb-[.25rem] opacity-100 text-gray-400 uppercase tracking-wide font-medium text-[11.5px] gap-1 {$$props.class ??
			''}">
		<slot />
		{#if instructions}
			<Instructions instructions="{instructions}" />
		{/if}
	</div>
{/if}
